export const download = (blogData: any, fileName: string) => {
  const blob = new Blob([blogData])
  const a = window.document.createElement('a')

  a.href = window.URL.createObjectURL(blob)
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
